import React, { useState, useEffect, useRef } from 'react'
import styles from './styles.module.scss'
import config from 'config'
import { useTranslation } from 'react-i18next'
import Button from '../components/common2/Button'
import Accordion from 'srcReact/components/common2/Accordion'
import { decode_utf8, getCookie, setCookie, setCookieForNativeApp } from 'srcReact/helpers/utils'
import ReactGA from 'react-ga'
import history from 'srcReact/helpers/history'
import { commonActions } from 'srcReact/components'
import { useDispatch, useSelector } from 'react-redux'
import queryString from 'query-string'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import Modal from 'srcReact/components/common2/Modal'

function GDPRCookieConsent(props) {
  const { isOpen = false, screen = 'main', closeGDPRModal } = props
  const cookieUpdated = useRef(false)

  const {
    common: { isNative, isDesktop, isPopinOpen, gdpr },
    login: { loggedIn, logged }
  } = useSelector((state) => state)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [screenType, setScreenType] = useState('main')

  const [currentPerformanceCookie, setCurrentPerformanceCookie] = useState(0)
  const [currentFunctionalCookies, setCurrentFunctionalCookies] = useState(0)
  const [currentMarketingCookies, setCurrentMarketingCookies] = useState(0)

  const loadLinkedInCookies = () => {
    const _linkedin_partner_id = '2539516'
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []
    window._linkedin_data_partner_ids.push(_linkedin_partner_id)

    const s = document.getElementsByTagName('script')[0]

    const b = document.createElement('script')
    b.type = 'text/javascript'
    b.async = true
    b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'
    s.parentNode.insertBefore(b, s)

    const img = new Image(1, 1)
    img.src = 'https://px.ads.linkedin.com/collect/?pid=2539516&fmt=gif'
    img.alt = ''
    img.style.display = 'none'
    document.body.appendChild(img)
  }

  const loadGoogleAnalyticsCookies = () => {
    const trackingId = 'UA-87414740-1'
    ReactGA.initialize(trackingId, {
      titleCase: false,
      gaOptions: {
        siteSpeedSampleRate: 100
      }
    })

    history.listen((location, action) => {
      // Initialize google analytics page view tracking
      ReactGA.set({ page: location.pathname }) // Update the user's current page
      ReactGA.pageview(location.pathname) // Record a pageview for the given page
    })
  }

  const data = [
    {
      id: 1,
      title: t('gdpr.necessary'),
      description: t('gdpr.necessaryDesc'),
      switch: t('gdpr.alwaysActive')
    },
    {
      id: 2,
      title: t('gdpr.performance'),
      description: t('gdpr.performanceDesc'),
      switch: currentPerformanceCookie
    },
    {
      id: 3,
      title: t('gdpr.functional'),
      description: t('gdpr.functionalDesc'),
      switch: currentFunctionalCookies
    },
    {
      id: 4,
      title: t('gdpr.marketing'),
      description: t('gdpr.marketingDesc'),
      switch: currentMarketingCookies
    }
  ]

  useEffect(() => {
    const query = queryString.parse(location.search)
    // check if gdpr cookie modal is already opened and accepted on webflow pages
    if (!isUserAuthorized()) {
      if (query?.gdpr_wf) {
        const gdprCookieFromWebflow = JSON.parse(decode_utf8(query.gdpr_wf))
        if (gdprCookieFromWebflow) {
          const marketing = gdprCookieFromWebflow.consents.analytics ? 1 : 0
          const performance = gdprCookieFromWebflow.consents.marketing ? 1 : 0
          const functional = gdprCookieFromWebflow.consents.personalisation ? 1 : 0
          const gdpr = {
            performance: performance,
            functional: functional,
            marketing: marketing
          }
          setCookie('gdpr', JSON.stringify(gdpr), 365)
          if (isNative) setCookieForNativeApp(gdpr)
          updateGDPRState(gdpr)
        }
      } else if (getCookie('gdpr') === null) {
        openModal()
      }
    } else {
      if (getCookie('gdpr') !== null) {
        let gdprCookie = getCookie('gdpr')
        gdprCookie = JSON.parse(gdprCookie)
        updateGDPRState(gdprCookie)
        //}
      }
      dispatch(commonActions.getGDPR())
    }
  }, [])

  useEffect(() => {
    if (loggedIn && logged) {
      dispatch(commonActions.getGDPR())
    }
  }, [loggedIn, logged])

  useEffect(() => {
    if (!gdpr.loading && gdpr.success && gdpr.settings) {
      if (getCookie('gdpr') !== null && !cookieUpdated.current && isUserAuthorized()) {
        // if gdpr cookie already exist on non-authorized page, then save it in databse upon login
        const existingGDPR = JSON.parse(getCookie('gdpr'))
        cookieUpdated.current = true
        dispatch(commonActions.updateGDPR(existingGDPR.performance, existingGDPR.functional, existingGDPR.marketing))
      } else if (!cookieUpdated.current) {
        const { with_functional_cookies, with_marketing_cookies, with_performance_cookies } = gdpr.settings
        if (with_functional_cookies === -1 && with_marketing_cookies === -1 && with_performance_cookies === -1) {
          openModal()
        }
      }
    }
  }, [gdpr])

  useEffect(() => {
    if (!isPopinOpen && closeGDPRModal) {
      closeGDPRModal()
    }
  }, [isPopinOpen])

  useEffect(() => {
    if (currentPerformanceCookie === 1 && currentFunctionalCookies === 1 && currentMarketingCookies === 1) {
      loadLinkedInCookies()
    } else if (currentPerformanceCookie === 1) {
      loadGoogleAnalyticsCookies()
    }
  }, [currentPerformanceCookie, currentFunctionalCookies, currentMarketingCookies])

  useEffect(() => {
    if (isOpen) {
      openModal()
    }
  }, [isOpen])

  useEffect(() => {
    setScreenType(screen)
  }, [screen])

  const updateGDPRState = (gdprData) => {
    setCurrentFunctionalCookies(gdprData.functional)
    setCurrentPerformanceCookie(gdprData.performance)
    setCurrentMarketingCookies(gdprData.marketing)
  }

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    if (closeGDPRModal) {
      closeGDPRModal()
    }
  }

  const showScreen = (type) => {
    setScreenType(type)
  }

  const handleSwitchChange = (id, value) => {
    if (id === 2) {
      setCurrentPerformanceCookie(value)
    } else if (id === 3) {
      setCurrentFunctionalCookies(value)
    } else if (id === 4) {
      setCurrentMarketingCookies(value)
    }
  }

  const acceptAllCookies = () => {
    const gdpr = {
      performance: 1,
      functional: 1,
      marketing: 1
    }
    setCurrentFunctionalCookies(1)
    setCurrentMarketingCookies(1)
    setCurrentPerformanceCookie(1)
    setCookie('gdpr', JSON.stringify(gdpr), 365)
    if (isNative) setCookieForNativeApp(gdpr)
    closeModal()
  }

  const confirm = () => {
    const gdpr = {
      performance: currentPerformanceCookie,
      functional: currentFunctionalCookies,
      marketing: currentMarketingCookies
    }
    setCookie('gdpr', JSON.stringify(gdpr), 365)
    if (isNative) setCookieForNativeApp(gdpr)
    if (isUserAuthorized()) {
      dispatch(commonActions.updateGDPR(currentPerformanceCookie, currentFunctionalCookies, currentMarketingCookies))
    }
    closeModal()
  }

  const popupContent = (
    <div className={styles.gdprContainer}>
      <img className={styles.mixrImg} alt='' src={`${config.assetUrl}/images/logo-mixr.png`} />
      {screenType === 'main' ? (
        <React.Fragment>
          <h1 className={styles.title}>{t('gdpr.title')}</h1>
          <h2 className={styles.subTitle}>{t('gdpr.subtitle')}</h2>
          <Button
            size='large'
            type='button'
            handleClick={acceptAllCookies}
            customStyle={styles.buttonMargin}
            text={t('gdpr.btnAcceptAll')}
          />
          <Button
            size='large'
            type='button'
            handleClick={() => showScreen('setting')}
            customStyle={styles.button}
            style='secondary'
            text={t('gdpr.btnSettings')}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <h1 className={styles.title}> {t('gdpr.cookieSettings')}</h1>
          <Accordion
            data={data}
            className={styles.accordion}
            arrowPosition='start'
            withSwitch={true}
            handleSwitchChange={handleSwitchChange}
          />
          <div className={styles.buttonWrapper}>
            <Button
              customStyle={isNative && styles.isNative}
              type='button'
              size='large'
              text={t('global.cancel')}
              style='secondary'
              handleClick={() => showScreen('main')}
            />
            <Button
              customStyle={isNative && styles.isNative}
              size='large'
              type='button'
              text={t('gdpr.confirmChoices')}
              handleClick={confirm}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  )

  return (
    <Modal isOpen={isModalOpen} handleClose={closeModal} customContentStyle={{ width: isDesktop ? '50%' : '90%' }}>
      {popupContent}
    </Modal>
  )
}

export default GDPRCookieConsent
